import { Wizard_Mode } from '../../shared/enums'
import { IProtocol, IFile, IField } from '../../shared/interfaces'

export interface ProtocolWizardReduxState {
    wizardMode: Wizard_Mode,
    protocol: IProtocol,
    docInFields?: IField[],
    docOutFields?: IField[],
    docInternalFields?: IField[],
    pageScaledWidth: number
    pageScaledHeight: number
    valid: boolean,
    touched: boolean,
    selectedPrinterName: string | undefined
    documentFileSource: string;
    attachmentFileSource: string;
    documentScannerFields: IField[];
    attachmentScannerFields: IField[];
    documentScannerLoader: boolean;
    attachmentScannerLoader: boolean;


}

export const SET_WIZARD_INITIAL_STATE = 'SET_WIZARD_INITIAL_STATE'
interface SetInitialStateAction {
    type: typeof SET_WIZARD_INITIAL_STATE
    wizardMode: Wizard_Mode
}
export const SET_WIZARD_DOCUMENT_FILE = 'SET_WIZARD_DOCUMENT_FILE'
interface SetDocumentFileAction {
    type: typeof SET_WIZARD_DOCUMENT_FILE
    documentFile: IFile | undefined
}
export const SET_WIZARD_ATTACHMENTS = 'SET_WIZARD_ATTACHMENTS'
interface SetAttachmentsAction {
    type: typeof SET_WIZARD_ATTACHMENTS
    attachmentsFile: IFile[]
}
export const ADD_WIZARD_ATTACHMENT = 'ADD_WIZARD_ATTACHMENT'
interface AddAttachmentAction {
    type: typeof ADD_WIZARD_ATTACHMENT
    attachmentFile: IFile
}
export const UPDATE_WIZARD_ATTACHMENT = 'UPDATE_WIZARD_ATTACHMENT'
interface UpdateAttachmentAction {
    type: typeof UPDATE_WIZARD_ATTACHMENT
    attachmentFile: IFile
}

export const SET_WIZARD_PROTOCOL = 'SET_WIZARD_PROTOCOL'
interface SetProtocolAction {
    type: typeof SET_WIZARD_PROTOCOL
    protocol: IProtocol
}

export const SET_WIZARD_DOCUMENT_SCANNER_LOADER = 'SET_WIZARD_DOCUMENT_SCANNER_LOADER'
interface SetDocumentScannerLoaderAction {
    type: typeof SET_WIZARD_DOCUMENT_SCANNER_LOADER
    documentScannerLoader: boolean
}

export const SET_WIZARD_ATTACHMENT_SCANNER_LOADER = 'SET_WIZARD_ATTACHMENT_SCANNER_LOADER'
interface SetAttachmentScannerLoaderAction {
    type: typeof SET_WIZARD_ATTACHMENT_SCANNER_LOADER
    attachmentScannerLoader: boolean
}

export const SET_WIZARD_SELECTED_PRINTER_NAME = 'SET_WIZARD_SELECTED_PRINTER_NAME'
interface SetSelectedPrinterName {
    type: typeof SET_WIZARD_SELECTED_PRINTER_NAME
    selectedPrinterName: string 
}

export const UPDATE_WIZARD_PROTOCOL_STATE = 'UPDATE_WIZARD_PROTOCOL_STATE'
interface UpdateCreateProtocolStateAction {
    type: typeof UPDATE_WIZARD_PROTOCOL_STATE
    payload: Partial<ProtocolWizardReduxState>
}

export const SET_WIZARD_PROTOCOL_TOUCHED = 'SET_WIZARD_PROTOCOL_TOUCHED'
interface SetProtocolWizardTouchedAction {
    type: typeof SET_WIZARD_PROTOCOL_TOUCHED
}


export type ProtocolWizardActionTypes = SetInitialStateAction | SetDocumentFileAction | SetAttachmentsAction | AddAttachmentAction | UpdateAttachmentAction | SetProtocolAction | SetSelectedPrinterName
    | UpdateCreateProtocolStateAction | SetProtocolWizardTouchedAction | SetDocumentScannerLoaderAction | SetAttachmentScannerLoaderAction